(() => {
  const cfg = window.Padelilli || {};
  const rootUrl = cfg.root || window.Shopify?.routes?.root || '/';
  const KEYS = {
    wishlist: 'pdl_wishlist_v1',
    compare: 'pdl_compare_v1',
    recent: 'pdl_recent_v1',
    searches: 'pdl_search_history_v1'
  };

  const read = (key, fallback = []) => {
    try { return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback)); }
    catch (_error) { return fallback; }
  };
  const write = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (_error) {}
  };
  const money = (value) => {
    const amount = Number(value || 0);
    const normalized = amount > 100000 ? amount / 100 : amount;
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: cfg.currency || 'MXN', maximumFractionDigits: 0 }).format(normalized);
    } catch (_error) {
      return '$' + Math.round(normalized).toLocaleString('es-MX');
    }
  };
  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));

  const normalizeQuery = (input) => {
    let q = String(input || '').trim().toLowerCase();
    const fixes = {
      'metlbone': 'metalbone',
      'metal bone': 'metalbone',
      'noks': 'nox',
      'noxx': 'nox',
      'bull padel': 'bullpadel',
      'adiddas': 'adidas',
      'adiddas': 'adidas'
    };
    Object.entries(fixes).forEach(([from, to]) => { q = q.replaceAll(from, to); });
    q = q
      .replace(/pala(s)?\s+que\s+tenga\s+mucho\s+control/g, 'control')
      .replace(/pala(s)?\s+de\s+mucho\s+control/g, 'control')
      .replace(/pala(s)?\s+que\s+tenga\s+mucha\s+potencia/g, 'potencia')
      .replace(/pala(s)?\s+de\s+mucha\s+potencia/g, 'potencia')
      .replace(/pala(s)?\s+barata(s)?/g, 'palas')
      .replace(/descuentos?/g, 'ofertas');
    return q.trim();
  };

  const updateCounts = () => {
    const wish = read(KEYS.wishlist);
    const compare = read(KEYS.compare);
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => el.textContent = wish.length);
    document.querySelectorAll('[data-compare-count]').forEach((el) => el.textContent = compare.length);
    document.querySelectorAll('[data-wishlist]').forEach((button) => {
      button.classList.toggle('is-active', wish.some((item) => item.handle === button.dataset.handle));
    });
    document.querySelectorAll('[data-compare]').forEach((button) => {
      button.classList.toggle('is-active', compare.some((item) => item.handle === button.dataset.handle));
    });
  };

  const snapshotFromButton = (button) => ({
    handle: button.dataset.handle || '',
    title: button.dataset.title || '',
    vendor: button.dataset.vendor || '',
    price: button.dataset.price || '',
    image: button.dataset.image || '',
    url: button.dataset.url || '',
    shape: button.dataset.shape || '',
    level: button.dataset.level || '',
    style: button.dataset.style || '',
    material: button.dataset.material || ''
  });

  const toggleItem = (key, item, max = 50) => {
    const current = read(key);
    const index = current.findIndex((entry) => entry.handle === item.handle);
    if (index >= 0) current.splice(index, 1);
    else current.unshift(item);
    write(key, current.slice(0, max));
    updateCounts();
  };

  const removeDrawer = () => {
    document.querySelectorAll('.pdl-compare-drawer,.pdl-wishlist-drawer').forEach((node) => node.remove());
  };

  const renderDrawer = (type) => {
    removeDrawer();
    const key = type === 'wishlist' ? KEYS.wishlist : KEYS.compare;
    const items = read(key);
    const drawer = document.createElement('aside');
    drawer.className = type === 'wishlist' ? 'pdl-wishlist-drawer' : 'pdl-compare-drawer';
    drawer.setAttribute('aria-label', type === 'wishlist' ? 'Favoritos' : 'Comparar palas');
    const cards = items.length ? items.map((item) => `
      <article class="pdl-compare-card">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}
        <small>${escapeHtml(item.vendor)}</small>
        <strong>${escapeHtml(item.title)}</strong>
        <div class="pdl-compare-meta">
          ${item.shape ? `<span>Forma: ${escapeHtml(item.shape)}</span>` : ''}
          ${item.level ? `<span>Nivel: ${escapeHtml(item.level)}</span>` : ''}
          ${item.style ? `<span>Juego: ${escapeHtml(item.style)}</span>` : ''}
          ${item.material ? `<span>Material: ${escapeHtml(item.material)}</span>` : ''}
          <span>${escapeHtml(item.price)}</span>
        </div>
        <div class="pdl-drawer-actions">
          <a href="${escapeHtml(item.url)}">VER PALA</a>
          <button type="button" data-remove-drawer-item="${escapeHtml(item.handle)}">QUITAR</button>
        </div>
      </article>
    `).join('') : '<p>Aún no has guardado palas aquí.</p>';
    drawer.innerHTML = `
      <div class="pdl-drawer-head">
        <strong>${type === 'wishlist' ? 'MIS FAVORITOS' : 'COMPARAR PALAS'} (${items.length})</strong>
        <button type="button" aria-label="Cerrar" data-drawer-close>×</button>
      </div>
      <div class="pdl-compare-grid">${cards}</div>
    `;
    document.body.appendChild(drawer);
    drawer.querySelector('[data-drawer-close]')?.addEventListener('click', removeDrawer);
    drawer.querySelectorAll('[data-remove-drawer-item]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = read(key).filter((item) => item.handle !== button.dataset.removeDrawerItem);
        write(key, next);
        renderDrawer(type);
        updateCounts();
      });
    });
  };

  const initProductActions = (scope = document) => {
    scope.querySelectorAll('[data-wishlist]').forEach((button) => {
      if (button.dataset.pdlBound) return;
      button.dataset.pdlBound = 'true';
      button.addEventListener('click', () => toggleItem(KEYS.wishlist, snapshotFromButton(button), 50));
    });
    scope.querySelectorAll('[data-compare]').forEach((button) => {
      if (button.dataset.pdlBound) return;
      button.dataset.pdlBound = 'true';
      button.addEventListener('click', () => {
        const item = snapshotFromButton(button);
        const current = read(KEYS.compare);
        const exists = current.some((entry) => entry.handle === item.handle);
        if (!exists && current.length >= 4) {
          current.pop();
          write(KEYS.compare, current);
        }
        toggleItem(KEYS.compare, item, 4);
      });
    });
    updateCounts();
  };

  const searchDialog = () => document.querySelector('[data-search-dialog]');
  const renderSearchHistory = () => {
    const holder = document.querySelector('[data-search-history]');
    if (!holder) return;
    const history = read(KEYS.searches).slice(0, 6);
    holder.innerHTML = history.length ? history.map((term) => `<button type="button" data-history-query="${escapeHtml(term)}">${escapeHtml(term)}</button>`).join('') : '<span>Aún no hay búsquedas recientes.</span>';
    holder.querySelectorAll('[data-history-query]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = document.querySelector('[data-predictive-input]');
        if (!input) return;
        input.value = button.dataset.historyQuery;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  };

  const renderPredictive = (payload, query) => {
    const results = document.querySelector('[data-predictive-results]');
    const empty = document.querySelector('[data-search-empty]');
    if (!results || !empty) return;
    const data = payload?.resources?.results || {};
    const products = (data.products || []).filter((item) => !/reno padel/i.test((item.vendor || '') + ' ' + (item.title || ''))).slice(0, 6);
    const collections = (data.collections || []).filter((item) => !/reno padel/i.test(item.title || '')).slice(0, 5);
    const queries = (data.queries || []).slice(0, 5);
    const productHtml = products.length ? products.map((product) => {
      const image = product.image || product.featured_image?.url || product.featured_image || '';
      return `
        <a class="pdl-predictive-item" href="${escapeHtml(product.url)}">
          ${image ? `<img src="${escapeHtml(image)}" alt="">` : '<span></span>'}
          <span><small>${escapeHtml(product.vendor || '')}</small><strong>${escapeHtml(product.title)}</strong></span>
          <span class="pdl-predictive-price">${money(product.price)}</span>
        </a>
      `;
    }).join('') : '<p>No encontramos productos con esa búsqueda.</p>';
    const side = [...collections.map((item) => ({title:item.title,url:item.url})), ...queries.map((item) => ({title:item.text || item.styled_text || query,url:(cfg.routes?.search || '/search') + '?q=' + encodeURIComponent(item.text || query)}))];
    results.innerHTML = `
      <div>
        <span class="pdl-search-kicker">PRODUCTOS</span>
        <div class="pdl-predictive-products">${productHtml}</div>
      </div>
      <div class="pdl-predictive-side">
        <span class="pdl-search-kicker">DESCUBRIR</span>
        ${side.length ? side.map((item) => `<a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>`).join('') : '<span>Prueba con NOX, Adidas, control o potencia.</span>'}
      </div>
    `;
    empty.hidden = true;
    results.hidden = false;
  };

  let predictiveTimer;
  const initPredictiveSearch = () => {
    document.querySelectorAll('[data-search-open]').forEach((button) => {
      if (button.dataset.pdlBound) return;
      button.dataset.pdlBound = 'true';
      button.addEventListener('click', () => {
        const dialog = searchDialog();
        if (!dialog) return;
        renderSearchHistory();
        dialog.showModal();
        requestAnimationFrame(() => dialog.querySelector('[data-predictive-input]')?.focus());
      });
    });
    document.querySelector('[data-search-close]')?.addEventListener('click', () => searchDialog()?.close());
    const input = document.querySelector('[data-predictive-input]');
    const form = document.querySelector('[data-predictive-form]');
    if (!input || !form || input.dataset.pdlBound) return;
    input.dataset.pdlBound = 'true';

    input.addEventListener('input', () => {
      clearTimeout(predictiveTimer);
      const raw = input.value.trim();
      const results = document.querySelector('[data-predictive-results]');
      const empty = document.querySelector('[data-search-empty]');
      if (raw.length < 2) {
        if (results) results.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }
      predictiveTimer = window.setTimeout(async () => {
        const q = normalizeQuery(raw);
        try {
          const endpoint = `${rootUrl}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last`;
          const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('search');
          renderPredictive(await response.json(), q);
        } catch (_error) {}
      }, 180);
    });

    form.addEventListener('submit', () => {
      const q = normalizeQuery(input.value);
      if (q) {
        input.value = q;
        const history = read(KEYS.searches).filter((item) => item !== q);
        history.unshift(q);
        write(KEYS.searches, history.slice(0, 8));
      }
    });
  };

  const initHeaderDrawers = () => {
    document.querySelectorAll('[data-wishlist-open]').forEach((button) => {
      if (button.dataset.pdlBound) return;
      button.dataset.pdlBound = 'true';
      button.addEventListener('click', () => renderDrawer('wishlist'));
    });
    document.querySelectorAll('[data-compare-open]').forEach((button) => {
      if (button.dataset.pdlBound) return;
      button.dataset.pdlBound = 'true';
      button.addEventListener('click', () => renderDrawer('compare'));
    });
  };


  const initCardTilt = (scope = document) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth < 900) return;
    scope.querySelectorAll('.product-card').forEach((card) => {
      if (card.dataset.pdlTiltBound) return;
      card.dataset.pdlTiltBound = 'true';
      const image = card.querySelector('.product-image');
      if (!image) return;
      image.addEventListener('pointermove', (event) => {
        const rect = image.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        card.style.setProperty('--pdl-ry', (x * 14).toFixed(2) + 'deg');
        card.style.setProperty('--pdl-rx', (-y * 9).toFixed(2) + 'deg');
        card.style.setProperty('--pdl-tx', (x * 8).toFixed(2) + 'px');
        card.style.setProperty('--pdl-ty', (y * 6).toFixed(2) + 'px');
        card.style.setProperty('--pdl-z', '28px');
        card.dataset.pdlTiltActive = 'true';
      });
      image.addEventListener('pointerleave', () => {
        card.style.removeProperty('--pdl-ry');
        card.style.removeProperty('--pdl-rx');
        card.style.removeProperty('--pdl-tx');
        card.style.removeProperty('--pdl-ty');
        card.style.removeProperty('--pdl-z');
        card.dataset.pdlTiltActive = 'false';
      });
    });
  };

  const initialize = (scope = document) => {
    initProductActions(scope);
    initPredictiveSearch();
    initHeaderDrawers();
    initCardTilt(scope);
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();